import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input, TemplateRef } from "@angular/core";

@Component({
	selector: "pv-locked-input",
	styleUrls: ["input.component.scss"],
	templateUrl: "./input.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LockedInputComponent {
	@Input() value: any;
	@Input() label: string;
	@Input() icon: string;
	@Input() inputClass = "";
	@ContentChild("valueTemplate", { static: false }) valueTemplate: TemplateRef<ElementRef>;

	public generateContext(element: any): any {
		return {
			$implicit: element,
		};
	}
}
